import type { SnackList } from "@/lib/gql/__generated__/graphql";

import { useSnackSettingsFormModelBgImageMethods } from "./bg-image";
import { useSnackSettingsFormModelContentsMethods } from "./contents";
import { useSnackSettingsFormModelLanguageSwitcherMethods } from "./language-switcher";
import { useSnackSettingsFormModelLogoImageMethods } from "./logo-image";
import { useSnackSettingsFormModelSNSMethods } from "./sns";

import type { DesignSnackLayoutSettingsFormModelOnSetViewModelType } from "..";
import type { DesignSnackBlocksFormModel } from "../type";
import type { SnackBlocksFormModelBgImageMethodsType } from "./bg-image";
import type { SnackBlocksFormModelContentsMethodsType } from "./contents";
import type { SnackBlocksFormModelLogoImageMethodsType } from "./logo-image";
import type { SnackBlocksFormModelSNSMethodsType } from "./sns";

type Props = {
	viewModel: DesignSnackBlocksFormModel["ViewModel"];
	onSetViewModel: DesignSnackLayoutSettingsFormModelOnSetViewModelType;
	snackList: SnackList;
};

export type SnackBlocksFormModelMethodsType = {
	bgImageMethods: SnackBlocksFormModelBgImageMethodsType;
	logoImageMethods: SnackBlocksFormModelLogoImageMethodsType;
	SNSMethods: SnackBlocksFormModelSNSMethodsType;
	contentsMethods: SnackBlocksFormModelContentsMethodsType;
	languageSwitcherMethods: {
		isShowLanguageSwitcher: boolean;
		handleChangeIsShowLanguageSwitcher: (value: string) => void;
	};
};

export const useSnackSettingsFormModelMethods = ({
	viewModel,
	onSetViewModel,
	snackList,
}: Props): SnackBlocksFormModelMethodsType => {
	return {
		bgImageMethods: useSnackSettingsFormModelBgImageMethods({
			viewModel,
			onSetViewModel,
		}),
		logoImageMethods: useSnackSettingsFormModelLogoImageMethods({
			viewModel,
			onSetViewModel,
		}),
		SNSMethods: useSnackSettingsFormModelSNSMethods({
			viewModel,
			onSetViewModel,
		}),
		contentsMethods: useSnackSettingsFormModelContentsMethods({
			viewModel,
			onSetViewModel,
			snackList,
		}),
		languageSwitcherMethods: useSnackSettingsFormModelLanguageSwitcherMethods({
			viewModel,
			onSetViewModel,
		}),
	};
};
